import { css } from '@emotion/css'
import type { RadioProps } from '@mantine/core'
import { Radio as MantineRadio } from '@mantine/core'
import type { FC } from 'react'
import React from 'react'
import { colors } from 'settings/colors'

export const Radio: FC<RadioProps> = (props) => {
  return (
    <MantineRadio
      size="sm"
      classNames={{
        radio: css({
          'backgroundColor': colors.grey200,
          'borderColor': colors.grey200,
          'boxShadow': 'inset 0px 2px 2px -1px rgba(74, 74, 104, 0.1)',
          '&:checked': {
            backgroundColor: colors.primary,
            borderColor: colors.primary,
          },
          '&:disabled': {
            backgroundColor: colors.grey200,
            borderColor: colors.grey200,
          },
        }),
        label: css({ '&:not([data-disabled])': { color: colors.midnight } }),
      }}
      {...props}
    />
  )
}
